/**
 * ????? ????API ???? ????.
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js????????????????? ???????? Authorization ???????????????.
 *
 * ????? ???: axios ??????????????? 401 ?????? ????, ?????????????????? ???.
 */
import api from './index'

/* ================================================================
 * ????? API
 * ================================================================ */

/**
 * ????? ?? ???? (??????????+ ?????????).
 * category LEFT JOIN???? ?????????? ???? ??????????.
 *
 * @param {Object} params - { keyword, categoryCode, viewYn, page, size }
 * @returns {Promise} { data: { items, total, page, size, totalPages }, code, message }
 */
export function getProductList(params) {
  return api.get('/api/v1/product', { params })
}

/**
 * ????? ????? ????.
 * productText(?????????)???????????? ???????????????.
 *
 * @param {string} productCode - ??????????
 * @returns {Promise} { productCode, categoryCode, categoryName, productName, productText, viewYn, ... }
 */
export function getProductDetail(productCode) {
  return api.get(`/api/v1/product/${productCode}`)
}

/**
 * ????? ??? (HQ ?????? ?????).
 *
 * @param {Object} data - { productName, categoryCode, productText }
 * @returns {Promise} ?????????? ????? ?????
 */
export function createProduct(data) {
  return api.post('/api/v1/product', data)
}

/**
 * ????? ??? ???? (HQ ?????? ?????).
 *
 * @param {string} productCode - ????????????????
 * @param {Object} data - { productName, categoryCode, productText }
 * @returns {Promise} ??????????? ????? ?????
 */
export function updateProduct(productCode, data) {
  return api.put(`/api/v1/product/${productCode}`, data)
}

/**
 * ????? ???????? ???? (HQ ?????? ?????).
 * view_yn 'Y' ??'N' ????? 'N' ??'Y' ??????? ?????????.
 *
 * @param {string} productCode - ????????????????
 * @returns {Promise} ????? ????? ????? ?????
 */
export function toggleProductView(productCode) {
  return api.post(`/api/v1/product/${productCode}/view`)
}

/**
 * ????? ???? (HQ ?????? ?????, soft delete).
 *
 * @param {string} productCode - ????????????????
 * @returns {Promise} { code, message }
 */
export function deleteProduct(productCode) {
  return api.delete(`/api/v1/product/${productCode}`)
}

/**
 * ????? ?????? ??????(HQ ?????? ?????).
 *
 * @param {string} productCode - ??????????
 * @param {string} fileType - thumbnail | detail
 * @param {File} file - ????????? ?????? ???
 * @returns {Promise} ProductDetailResponse
 */
export function uploadProductImage(productCode, fileType, file) {
  const formData = new FormData()
  formData.append('fileType', fileType)
  formData.append('file', file)
  return api.post(`/api/v1/product/${productCode}/images`, formData, {
    timeout: 60000,
    transformRequest: [(data, headers) => {
      if (data instanceof FormData && headers?.['Content-Type']) {
        delete headers['Content-Type']
      }
      return data
    }],
  })
}

/**
 * ????? ?????? ???? (HQ ?????? ?????).
 *
 * @param {string} productCode - ??????????
 * @param {number} seq - product_image.seq
 * @returns {Promise} ProductDetailResponse
 */
export function deleteProductImage(productCode, seq) {
  return api.delete(`/api/v1/product/${productCode}/images/${seq}`)
}
